import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// LCP shell is purely an above-the-fold paint so the brand logo renders
// before React mounts. Once React has the real header in the tree, drop it.
queueMicrotask(() => document.getElementById("lcp-shell")?.remove());
